import React from 'react'
import { Button } from '../ButtonElement';
import { InfoContainer, InfoWrapper, InfoRow, Column1, Column2, TextWrapper, TopLine, Heading, Subtitle, BtnWrap, ImgWrap, Img, Iframe } from './InfoElements';
import PdfButton from '../PdfButton';

const InfoSection = ({lightBg, id, imgStart, topLine, lightText, headline, darkText, description, buttonLabel, img, alt, primary, dark, dark2, scrollId, scrollId2, appear, iframeDisplay, imgDisplay, srcLink, appear2, buttonLabel2, appear3, pdfLink, pdfButtonLabel, appearPdfButton }) => {
    
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }

    const handleButtonClick = () => {
        scrollToTop();
    }

    return (
        <>
            <InfoContainer lightBg={lightBg} id={id}>
                <InfoWrapper>
                    <InfoRow imgStart={imgStart}>
                        <Column1>
                            <TextWrapper>
                                <TopLine>{topLine}</TopLine>
                                <Heading lightText={lightText}>{headline}</Heading>
                                <Subtitle darkText={darkText}>{description}</Subtitle>
                                <BtnWrap>
                                    {buttonLabel && <Button to={scrollId} smooth={true} duration={200} spy={true} exact="true" offset={-80} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 1 : 0} appear={appear} onClick={handleButtonClick}>{buttonLabel}</Button>}
                                    {buttonLabel2 && <Button to={scrollId2} smooth={true} duration={200} spy={true} exact="true" offset={-80} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 0 : 1} appear={appear2} onClick={handleButtonClick}>{buttonLabel2}</Button>}
                                    {appear3 && <Button as="a" href="mailto:tesini22@gmail.com" smooth={true} duration={200} spy={true} exact="true" offset={-80} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 0 : 1} appear={appear3} onClick={handleButtonClick}>Professional Contact</Button>}
                                    {appearPdfButton && <PdfButton pdfLink={pdfLink} pdfButtonLabel={pdfButtonLabel} primary={primary} dark={dark} dark2={dark2} />}
                                </BtnWrap>
                            </TextWrapper>
                        </Column1>
                        <Column2>
                            <ImgWrap>
                                <Img src={img} alt={alt} imgDisplay={imgDisplay}/>
                                <Iframe src={srcLink} width="100%" height="100%" frameBorder="0" marginHeight="0" marginWidth="0" iframeDisplay={iframeDisplay} allowFullScreen></Iframe>
                            </ImgWrap>
                        </Column2>
                    </InfoRow>
                </InfoWrapper>
            </InfoContainer>
        </>
    )
}

export default InfoSection;
